import { ContactModal } from "../components/ContactModal";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { useContactModal } from "../context/contactModal";
export const ComingSoonPage = ({ title }) => {
  const { isOpen, closeModal } = useContactModal();
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header forceLight={true} />
      <main className="flex-1 flex flex-col items-center justify-center px-4">
        <div className="text-center">
          <div className="text-6xl mb-6">🚀</div>
          <h1 className="text-3xl font-bold text-black mb-4">{title}</h1>
          <p className="text-gray-500 mb-8">This feature is coming soon. Stay tuned for updates!</p>
          <div className="inline-flex items-center px-4 py-2 bg-gray-100 rounded-full">
            <div className="flex space-x-2">
              <div
                className="w-2 h-2 bg-[#006AFF] rounded-full animate-bounce"
                style={{
                  animationDelay: "0ms",
                }}
              />
              <div
                className="w-2 h-2 bg-[#006AFF] rounded-full animate-bounce"
                style={{
                  animationDelay: "150ms",
                }}
              />
              <div
                className="w-2 h-2 bg-[#006AFF] rounded-full animate-bounce"
                style={{
                  animationDelay: "300ms",
                }}
              />
            </div>
            <span className="ml-2 text-base text-gray-600">Under Development</span>
          </div>
        </div>
      </main>
      <Footer />
      <ContactModal isOpen={isOpen} onClose={closeModal} />
    </div>
  );
};
